import type { IconData } from '@stacksjs/iconify-core'

export const bullhorn: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m429 15.933l-253.574 120H15.992v211.728l52.192 148.267h114.654l-46.56-128h35.847L431.182 496h64.735L496 15.933Zm-269.009 320h-56.025l.061 36.949l33.119 91.051h-46.3l-42.854-121.74V167.928h112Zm32.125-172.495l175.876-83.233v348.858l-175.875-86.949ZM463.923 464H438.66l-38.668-19.117V65.063l36.2-17.13h27.8Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default bullhorn
